import { render, staticRenderFns } from "./FiltrosClientesExtraCostosModal.vue?vue&type=template&id=c9097eb2"
import script from "./FiltrosClientesExtraCostosModal.vue?vue&type=script&lang=js"
export * from "./FiltrosClientesExtraCostosModal.vue?vue&type=script&lang=js"
import style0 from "./FiltrosClientesExtraCostosModal.vue?vue&type=style&index=0&id=c9097eb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports